import { Chat } from "@acoladgroup/tempo-messaging-library";
import { useGetTempoChatQuery } from "query/tempo-chat.query";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const useTempoChat = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const chatId = searchParams.get("chat");
  const [tempoChatData, setTempoChatData] = useState<Chat | null>(null);
  const fetchTempoChat = useGetTempoChatQuery();

  useEffect(() => {
    if (chatId) {
      fetchTempoChat(Number(chatId)).then(setTempoChatData);
    } else {
      setTempoChatData(null);
    }
  }, [chatId, fetchTempoChat]);

  const handleChatClose = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.delete("chat");
    setSearchParams(newParams, { replace: true });
    setTempoChatData(null);
  };

  return {
    tempoChatData,
    handleChatClose,
  };
};
